import { render } from "./ProduitMoinsVendus.vue?vue&type=template&id=43141492&scoped=true"
import script from "./ProduitMoinsVendus.vue?vue&type=script&lang=js"
export * from "./ProduitMoinsVendus.vue?vue&type=script&lang=js"

import "./ProduitMoinsVendus.vue?vue&type=style&index=0&id=43141492&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43141492"]])

export default __exports__